// recon-period-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'rcd.areaStatus.notStarted': 'Sin empezar',
  'rcd.areaStatus.inProgress': 'En curso',
  'rcd.areaStatus.waitingPeriodEnd': 'A la espera del cierre del periodo',
  'rcd.areaStatus.deviation': 'Desviación',
  'rcd.areaStatus.approved': 'Aprobada',
  'rcd.areaStatus.notRelevant': 'No aplica',
  'rcd.result.passed': 'Superado',
  'rcd.result.waiting': 'En espera',
  'rcd.result.deviation': 'Desviación',
  'rcd.result.blocked': 'Bloqueado',
  'rcd.result.notAssessed': 'Sin evaluar',
  'rcd.type.auto': 'Control automático',
  'rcd.type.professional': 'Valoración profesional',
  'rcd.type.controller': 'Control del revisor',
  'rcd.area.noExternalBalance': 'Sin saldo externo con el que comparar',
  'rcd.area.noBalanceChecklist': 'Sin saldo: el área son puntos de control',
  'rcd.area.unexplained': '{amount} sin explicar',
  'rcd.area.matchesLedger': 'Cuadra con el libro mayor',
  'rcd.area.checkpoints': 'Puntos de control del periodo',
  'rcd.area.accountOne': '{count} cuenta',
  'rcd.area.accountMany': '{count} cuentas',
  'rcd.area.noAccounts': 'Sin cuentas',
  'rcd.area.docsMissing': 'Faltan {count}',
  'rcd.area.docsComplete': 'Completa',
  'rcd.comp.inbox': 'Documentos sin contabilizar en la bandeja de entrada',
  'rcd.comp.received': 'Documentos recibidos pero no contabilizados',
  'rcd.comp.receivedNote': 'Incluidos en los documentos sin contabilizar de arriba: no se cuentan dos veces.',
  'rcd.comp.bankNoDoc': 'Movimientos bancarios sin justificante',
  'rcd.comp.docNoBank': 'Justificantes sin pago vinculado',
  'rcd.comp.duplicates': 'Justificantes con sospecha de duplicado',
  'rcd.comp.outsidePeriod': 'Asientos con fecha fuera del periodo',
  'rcd.comp.outsidePeriodNote': 'Plumme no registra la fecha de recepción junto a la fecha del justificante, así que no puede distinguir un asiento tardío correcto de uno con fecha errónea.',
  'rcd.comp.lateManual': 'Asientos manuales cerca del cierre del periodo',
  'rcd.comp.lateManualNote': 'Justificantes manuales con fecha de los últimos {days} días del periodo. Una sugerencia de qué revisar, no una afirmación de error.',
  'rcd.comp.cutoff': 'Posibles errores de corte contable',
  'rcd.comp.cutoffNote': 'Requiere una fecha de entrega o de recepción junto a la fecha del justificante. Plumme todavía no tiene ese registro.',
  'rcd.group.revenue': 'Ingresos',
  'rcd.group.cogs': 'Coste de mercancías',
  'rcd.group.payroll': 'Costes de nómina',
  'rcd.group.otherOpex': 'Otros gastos de explotación',
  'rcd.basis.previousMonth': 'Mes anterior',
  'rcd.basis.lastYear': 'Mismo periodo del año pasado',
  'rcd.basis.budget': 'Presupuesto',
  'rcd.basis.forecast': 'Previsión',
  'rcd.priority.critical': 'Crítica',
  'rcd.priority.high': 'Alta',
  'rcd.priority.normal': 'Normal',
  'rcd.taskStatus.open': 'Abierta',
  'rcd.taskStatus.waitingClient': 'A la espera del cliente',
  'rcd.taskStatus.needsReview': 'Pendiente de valoración',
  'rcd.taskStatus.resolved': 'Resuelta',
  'rcd.task.clientRequest': 'Solicitud al cliente',
  'rcd.task.docRequest': 'Solicitud de documentación',
  'rcd.task.inbox': 'Bandeja de entrada',
  'rcd.task.inboxRef': 'BANDEJA',
  'rcd.task.processInbox': 'Tramitar {count} documentos sin contabilizar',
  'rcd.reportStatus.notStarted': 'Sin empezar',
  'rcd.reportStatus.dataIncomplete': 'Datos incompletos',
  'rcd.reportStatus.readyToPrepare': 'Lista para elaborar',
  'rcd.reportStatus.readyToSubmit': 'Lista para presentar',
  'rcd.reportStatus.submitted': 'Presentada',
  'rcd.reportStatus.waitingPeriodEnd': 'A la espera del cierre del periodo',
  'rcd.report.period': 'Informe del periodo para el cliente',
  'rcd.report.result': 'Informe de resultados',
  'rcd.report.balance': 'Informe de balance',
  'rcd.report.ledger': 'Libro mayor',
  'rcd.report.aged': 'Listado de clientes y proveedores por antigüedad',
  'rcd.report.dataComplete': 'Completos',
  'rcd.report.dataIncomplete': 'Incompletos',
  'rcd.report.dueOwn': 'Plazo propio del despacho para el periodo',
  'rcd.report.dueNone': 'No hay ningún plazo definido para el periodo',
  'rcd.report.vat': 'Declaración de IVA',
  'rcd.report.vatTerm': 'Periodo {term} de {year}',
  'rcd.report.dueVatModel': 'Calculado por el modelo de periodos de IVA',
  'rcd.report.aMelding': 'A-melding',
  'rcd.report.withholding': 'Retenciones y cotización del empleador',
  'rcd.report.dueNotRegistered': 'Plazo no registrado en Plumme: se gestiona en el área de nómina',
  'rcd.master.bank': 'Todas las cuentas bancarias están conciliadas',
  'rcd.master.subledger': 'Los auxiliares de clientes y proveedores están conciliados',
  'rcd.master.vat': 'El IVA está revisado',
  'rcd.master.payroll': 'La nómina y los tributos públicos están revisados',
  'rcd.master.docs': 'La documentación está completa',
  'rcd.master.docsSource': '{area}: {count} cuenta(s) sin documentación',
  'rcd.master.docsAllOk': 'Todas las cuentas que requieren un soporte externo tienen documentación o una nota',
  'rcd.master.docsText': 'Desviación: faltan {count} requisitos de documentación',
  'rcd.master.reporting': 'El periodo está listo para su presentación',
  'rcd.cross.unexplainedDiff': 'Diferencia sin explicar',
  'rcd.cross.matches': 'Cuadra',
  'rcd.cross.ledgerRule': 'El libro mayor cuadra, con sumas iguales en el Debe y en el Haber.',
  'rcd.cross.srcLedger': 'Libro mayor',
  'rcd.cross.ledgerOff': 'El Debe y el Haber no cuadran',
  'rcd.cross.bankRule': 'Los saldos bancarios cuadran con las conciliaciones bancarias.',
  'rcd.cross.srcBank': 'Banco, libro mayor',
  'rcd.cross.subledgerRule': 'Los auxiliares de clientes y proveedores cuadran con el libro mayor.',
  'rcd.cross.srcSubledger': 'Cuentas a cobrar, cuentas a pagar, libro mayor',
  'rcd.cross.vatRule': 'La base del IVA cuadra con las cuentas relevantes del libro mayor.',
  'rcd.cross.srcVat': 'Conciliación del IVA, libro mayor',
  'rcd.cross.payrollRule': 'La base de nómina cuadra con el proceso de nómina y el libro mayor.',
  'rcd.cross.srcPayroll': 'Sistema de nómina, libro mayor, A-melding',
  'rcd.cross.taxRule': 'Las retenciones y los tributos públicos cuadran con la base de nómina y tributos.',
  'rcd.cross.srcTax': 'Sistema de nómina, cuenta tributaria',
  'rcd.cross.waitingPeriodEnd': 'A la espera del cierre del periodo',
  'rcd.cross.signRule': 'Se han examinado las cuentas de activo con saldo negativo.',
  'rcd.cross.srcTrialBalance': 'Balance de comprobación',
  'rcd.cross.negativeAccounts': '{count} cuenta(s) con saldo negativo',
  'rcd.cross.noneFound': 'Ninguna encontrada',
  'rcd.cross.unclearedRule': 'Se han revisado las cuentas transitorias y pendientes de aclarar.',
  'rcd.cross.srcOther': 'Resto del balance',
  'rcd.cross.openItems': '{count} partidas abiertas',
  'rcd.cross.noOpenItems': 'Sin partidas abiertas',
  'rcd.cross.itemsRule': 'Todas las partidas de conciliación relevantes están tratadas o documentadas para su seguimiento.',
  'rcd.cross.srcAllAreas': 'Todas las áreas',
  'rcd.cross.itemsStillOpen': '{count} partidas aún abiertas',
  'rcd.cross.allItemsDone': 'Todas las partidas están tratadas',
  'rcd.cross.itemsCount': '{count} partidas',
  'rcd.cross.changedRule': 'Ninguna conciliación aprobada se ha modificado sin un nuevo control.',
  'rcd.cross.srcActivityLog': 'Registro de actividad',
  'rcd.cross.changedAfterApproval': 'Modificado tras la aprobación: {areas}',
  'rcd.cross.areasCount': '{count} áreas',
  'rcd.auto.noAccountsInArea': 'Sin cuentas en el área',
  'rcd.auto.a1': 'Todas las áreas de conciliación relevantes están identificadas.',
  'rcd.auto.a1Source': '{count} áreas identificadas a partir de la configuración del cliente',
  'rcd.auto.a2': 'Todas las cuentas bancarias están conciliadas.',
  'rcd.auto.a3': 'Los auxiliares de clientes y proveedores están conciliados.',
  'rcd.auto.a4': 'El IVA está revisado cuando es relevante para el periodo.',
  'rcd.auto.a5': 'La nómina y los tributos públicos están revisados cuando es relevante.',
  'rcd.auto.a6': 'Todas las áreas relevantes del balance están tratadas.',
  'rcd.auto.b2': 'Se ha hecho el seguimiento de los movimientos bancarios sin documentación.',
  'rcd.auto.b2Source': '{count} movimientos bancarios sin justificante',
  'rcd.auto.b2NoBank': 'Sin conciliación bancaria en el periodo',
  'rcd.auto.c1': 'La evolución del resultado se ha comparado con una base de comparación relevante.',
  'rcd.auto.c1Source': '{count} indicadores comparados con {basis}',
  'rcd.auto.c1NoLines': 'Sin líneas de la cuenta de resultados en el periodo',
  'rcd.auto.d1': 'La base de presentación parte de una base de conciliación sin cambios.',
  'rcd.auto.d1Unchanged': 'Ninguna conciliación aprobada se ha modificado después',
  'rcd.auto.d2': 'Todos los informes y obligaciones del periodo están identificados.',
  'rcd.auto.d2Source': '{count} informes/obligaciones identificados',
  'rcd.auto.d3': 'Los informes y las especificaciones tienen datos completos.',
  'rcd.auto.d3Source': '{count} informes tienen datos incompletos',
  'rcd.auto.d3AllComplete': 'Todos los informes tienen datos completos',
  'rcd.auto.d5': 'El periodo está listo para su revisión.',
  'rcd.auto.d5Blocked': 'Calculado: consulta los bloqueos en la conclusión',
  'rcd.auto.d5None': 'Sin bloqueos',
  'rcd.auto.d4': 'Las desviaciones analíticas están explicadas.',
  'rcd.auto.d4Source': '{count} desviaciones analíticas sin explicación',
  'rcd.auto.d4AllExplained': 'Todas las comparaciones están explicadas o dentro de lo esperado',
  'rcd.group.scope': 'A. Alcance y conciliaciones',
  'rcd.group.completeness': 'B. Integridad y periodificación',
  'rcd.group.analytical': 'C. Revisión analítica',
  'rcd.group.reporting': 'D. Presentación de informes',
  'rcd.group.professional': 'Valoraciones profesionales',
  'rcd.blocker.deviation': '{count} cuenta(s) figuran con desviación',
  'rcd.blocker.missingDocs': '{count} cuenta(s) sin documentación',
  'rcd.blocker.openItems': '{count} partidas de conciliación abiertas',
  'rcd.blocker.waitingTermEnd': 'A la espera del cierre del periodo: el periodo terminó el {date}',
  'rcd.blocker.basisMoved': 'La base ha cambiado desde la aprobación',
  'rcd.blocker.inboxGroup': 'Bandeja de entrada',
  'rcd.blocker.inboxItems': '{count} documentos sin tramitar',
  'rcd.blocker.analyticalGroup': 'Revisión analítica',
  'rcd.blocker.explanationsMissing': 'Faltan {count} explicaciones ({areas})',
  'rcd.blocker.periodGroup': 'El periodo',
  'rcd.blocker.periodNotEnded': 'El periodo aún no ha terminado',
});
